export default "__VITE_ASSET__CufKvf7A__"